import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  CLEAR_FORGOT_PASSWORD_STATE,
} from "../actions/forgotPasswordActions";

const initialState = {
  forgotPasswordLoading: false,
  forgotPasswordSuccessMessage: "",
  forgotPasswordError: "",
};

export default function forgotPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPasswordLoading: true,
        forgotPasswordSuccessMessage: "",
        forgotPasswordError: "",
      };

    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccessMessage: action.payload,
      };

    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordError: action.payload,
      };

    case CLEAR_FORGOT_PASSWORD_STATE:
      return {
        ...state,
        forgotPasswordLoading: false,
        forgotPasswordSuccessMessage: "",
        forgotPasswordError: "",
      };

    default:
      return state;
  }
}
